/* eslint-disable react/prop-types */
import { Button } from "@benefit-systems/common-components";
import { arrayOf, bool, func, number, shape, string } from "prop-types";

import __ from "web/Layout/Translations";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { BENEFIT_PRODUCT_TYPES } from "web/constants/benefits";

import classes from "../productCard.scss";
import PointsStatus from "./PointsStatus";
import Price from "./Price";
import UnavailableTooltip from "./UnavailableTooltip";

const ProductCardFooter = ({
  className,
  isUnavailable,
  payments,
  price,
  finalPrice,
  options,
  type,
  priceTourismDomestic,
  to,
  onClick,
}) => {
  switch (type) {
    case "universal_code": {
      const isConfigurable =
        options &&
        options.configurable_options &&
        isArrayHasItems(options.configurable_options.attributes);
      return isUnavailable ? (
        <UnavailableTooltip />
      ) : (
        <div className={className}>
          <Price
            finalPrice={finalPrice}
            isConfigurable={isConfigurable}
            price={price}
            to={to}
            dataT1="final_price"
            onClick={onClick}
          />
          <PointsStatus price={finalPrice} payments={payments} />
        </div>
      );
    }
    case "international_tourism_travelplanet":
    case "international_tourism_other": {
      return (
        <strong className={classes.tourismPayInfo}>
          {__("Zapłać punktami lub środkami własnymi")}
        </strong>
      );
    }
    case "anixe_tourism": {
      return priceTourismDomestic ? (
        <div className={className}>
          <Price
            finalPrice={priceTourismDomestic}
            isConfigurable
            price={priceTourismDomestic}
            to={to}
            onClick={onClick}
          />
        </div>
      ) : null;
    }
    case BENEFIT_PRODUCT_TYPES.GROUP_1:
    case BENEFIT_PRODUCT_TYPES.GROUP_2: {
      return finalPrice ? (
        <div className={className}>
          <Price
            finalPrice={finalPrice}
            isSubscription
            to={to}
            onClick={onClick}
          />
        </div>
      ) : (
        <div className={`${className} ${classes.checkButton}`}>
          <Button to={to} onClick={onClick}>
            {__("Sprawdź")}
          </Button>
        </div>
      );
    }
    default: {
      return null;
    }
  }
};

ProductCardFooter.propTypes = {
  className: string.isRequired,
  type: string.isRequired,
  to: shape({}).isRequired,
  isUnavailable: bool.isRequired,
  payments: arrayOf(shape({})),
  price: number.isRequired,
  finalPrice: number.isRequired,
  options: shape({}),
  onClick: func,
};

ProductCardFooter.defaultProps = {
  payments: [],
  options: {},
  onClick: () => {},
};

export default ProductCardFooter;
